<template>
  <div class="mkt-ops -main-font mktops-request-price">
    <div
      style="position: absolute;top: 50%; left: 50%; width: 10%; z-index: 8;"
      v-show="loading == true"
    >
      <md-progress-spinner
        :md-stroke="8"
        :md-diameter="65"
        md-mode="indeterminate"
      ></md-progress-spinner>
    </div>
    <div class="bg-backdrop -sparse" v-show="showBackdrop"></div>

    <div class="md-layout">
      <!-- HEAD PAGE -->
      <div class="md-layout-item md-size-100 head-page">MANAGE BOOK PRICE</div>
    </div>

    <!-- BLOCK ROW-1 -->
    <div class="md-layout -block">
      <div class="md-layout-item md-size-20">
        <div class="-label -title">Book Code</div>
        <div class="-label">{{ bookCode }}</div>
      </div>
      <div class="md-layout-item md-size-30">
        <div class="-label -title">Doc No.</div>
        <div class="-label">{{ docNo }}</div>
      </div>

      <div class="md-layout-item md-size-20">
        <div class="-label -title">Effective Date</div>
        <md-datepicker
          v-if="status === 'Draft' || status === '' || status === 'Return'"
          style="width: 75%;"
          autocomplete="off"
          ref="effective_date"
          class="custom-datepicker"
          v-model="effective_date"
          :md-immediately="true"
          :md-disabled-dates="disabledEffDates"
        ></md-datepicker>
        <div v-else>{{ effective_date }}</div>
      </div>

      <div class="md-layout-item md-size-30">
        <div class="-label -title">Expire Date</div>
        <md-datepicker
          v-if="status === 'Draft' || status === '' || status === 'Return'"
          style="width: 50%;"
          autocomplete="off"
          ref="expire_date"
          class="custom-datepicker"
          v-model="expire_date"
          :md-immediately="true"
          :md-disabled-dates="disabledExpDates"
        ></md-datepicker>
        <div v-else>{{ expire_date }}</div>
      </div>
    </div>

    <!-- BLOCK ROW-2 -->
    <div
      class="md-layout -block"
      :style="
        status === 'Draft' || status === '' || status === 'Return'
          ? 'padding-top: 12px;'
          : 'padding-top: 3px;'
      "
    >
      <div class="md-layout-item md-size-50">
        <div class="-label -title">Description</div>
        <div class="nowrap-title font-kanit" :title="desc">{{ desc }}</div>
      </div>
      <div class="md-layout-item md-size-20">
        <div class="-label -title">Create Date</div>
        <div>{{ c_date }}</div>
      </div>
      <div class="md-layout-item md-size-30">
        <div class="-label -title">Change % from price type</div>
        <div style="display: flex;">
          <md-radio
            v-show="radioType === 'typeA3'"
            v-model="radioType"
            value="typeA3"
            class="md-primary"
            >Price Type "A3"</md-radio
          >
          <md-radio
            v-show="radioType === 'typeSS'"
            v-model="radioType"
            value="typeSS"
            class="md-primary"
          >
            Price Type "SS"
          </md-radio>
        </div>
      </div>
    </div>

    <!-- BLOCK ROW-3 -->
    <div class="md-layout -block">
      <div
        class="md-layout-item md-size-10 pt23"
        style="font-size: 14px; font-weight: bold;"
        :style="
          status === 'Draft' || status === '' || status === 'Return'
            ? ''
            : 'padding-top: 12px;'
        "
      >
        Product in group
      </div>

      <!-- v-show="status === 'Draft' || status === ''" -->
      <div
        v-show="showIconFilterProduct"
        class="md-layout-item md-size-30 mktops-control-box"
        style="margin-top: 7px;"
      >
        <treeselect
          ref="productTxt"
          class="treeview-box"
          :multiple="true"
          :limit="1"
          :maxHeight="400"
          placeholder="+ Add with Product Code"
          :async="true"
          :load-options="loadOptions"
          :cache-options="false"
          v-model="valueTree"
          :value-consists-of="valueConsistsOf"
          :clearable="false"
          @select="OnSelectTreeview"
          @deselect="onDeSelectTreeview"
        >
          <!-- @open="onOpenTreeview" -->
          <label
            slot="option-label"
            slot-scope="{ node }"
            :title="node.label"
            class="nowrap-title"
            >{{ node.raw.code }} - {{ node.label }}</label
          >
        </treeselect>
      </div>

      <!-- v-show="status === 'Draft' || status === ''" -->
      <div
        class="md-layout-item md-size-10 pt23"
        :style="
          status === 'Draft' || status === '' || status === 'Return'
            ? ''
            : 'padding-top: 0px;'
        "
      >
        <i
          v-show="showIconFilterProduct"
          class="md-icon material-icons"
          style="color: #b3b3b3; cursor: pointer; margin-left: 10px;"
          title="Filter Product"
          @click="filterProduct()"
          >filter_list</i
        >
        <i
          v-show="showIconCompareCustomer"
          class="md-icon material-icons"
          style="color: #b3b3b3; cursor: pointer; margin-left: 10px;"
          title="Compare Customer"
          @click="compareCustomer()"
          >filter_list</i
        >
        <i
          v-show="showIconFilterProduct"
          class="md-icon material-icons"
          style="color: #b3b3b3; cursor: pointer; margin-left: 15px;"
          title="Delete"
          @click="deleteItems()"
          >delete_sweep</i
        >
      </div>

      <!-- v-show="status !== 'Draft' && status !== ''" -->
      <div
        v-show="!showIconFilterProduct"
        class="md-layout-item md-size-30 pt23"
        :style="
          status === 'Draft' || status === '' || status === 'Return'
            ? ''
            : 'padding-top: 0px;'
        "
      ></div>

      <div
        class="md-layout-item md-size-50 -action"
        style="padding-top: 12px;"
        :style="
          !showButtonTemplate && !showButtonImportTemplate
            ? 'height: 35px;'
            : ''
        "
      >
        <!-- <md-icon
          style="padding-top: 24px; margin-right: 10px; font-size: 28px !important; cursor: pointer;"
          title="Export Data"
          >file_download</md-icon
        > -->

        <!-- <md-button class="md-raised md-primary">IMPORT</md-button> -->

        <md-button
          v-show="showButtonTemplate"
          class="md-raised md-primary -flex"
          style="background-color: #d84710;"
          @click="onClickExportTemplate()"
        >
          <md-icon style="font-size: 18px !important;">file_download</md-icon>
          <div style="padding-top: 5px; padding-left: 5px; padding-right: 5px;">
            TEMPLATE
          </div>
        </md-button>

        <md-button
          v-show="showButtonImportTemplate"
          class="md-raised md-primary"
          @click="onClickImportFile()"
          >IMPORT TEMPLATE</md-button
        >
      </div>
    </div>
    <!-- BLOCK ROW-4 Temporary for initial data -->
    <div v-show="userActivity.user_group === 'Admin'" class="md-layout -block">
      <div
        class="md-layout-item md-size-10 pt23"
        style="font-size: 14px; font-weight: bold;"
        :style="
          status === 'Draft' || status === '' || status === 'Return'
            ? ''
            : 'padding-top: 12px;'
        "
      ></div>

      <!-- v-show="status === 'Draft' || status === ''" -->
      <div
        v-show="showIconFilterProduct"
        class="md-layout-item md-size-30 mktops-control-box"
        style="margin-top: 7px;"
      >
        <treeselect
          ref="productTxt2"
          class="treeview-box"
          :multiple="true"
          :limit="1"
          :maxHeight="400"
          placeholder="+ Add with Product Code"
          :async="true"
          :load-options="loadOptions2"
          :cache-options="false"
          v-model="valueTree"
          :value-consists-of="valueConsistsOf"
          :clearable="false"
          @select="OnSelectTreeview"
          @deselect="onDeSelectTreeview"
        >
          <!-- @open="onOpenTreeview" -->
          <label
            slot="option-label"
            slot-scope="{ node }"
            :title="node.label"
            class="nowrap-title"
            >{{ node.raw.code }} - {{ node.label }}</label
          >
        </treeselect>
      </div>

      <!-- v-show="status === 'Draft' || status === ''" -->
      <div
        class="md-layout-item md-size-10 pt23"
        :style="
          status === 'Draft' || status === '' || status === 'Return'
            ? ''
            : 'padding-top: 0px;'
        "
      ></div>

      <!-- v-show="status !== 'Draft' && status !== ''" -->
      <div
        v-show="!showIconFilterProduct"
        class="md-layout-item md-size-30 pt23"
        :style="
          status === 'Draft' || status === '' || status === 'Return'
            ? ''
            : 'padding-top: 0px;'
        "
      ></div>

      <div
        class="md-layout-item md-size-50 -action"
        style="padding-top: 12px;"
        :style="
          !showButtonTemplate && !showButtonImportTemplate
            ? 'height: 35px;'
            : ''
        "
      >
        <!-- <md-icon
          style="padding-top: 24px; margin-right: 10px; font-size: 28px !important; cursor: pointer;"
          title="Export Data"
          >file_download</md-icon
        > -->

        <!-- <md-button class="md-raised md-primary">IMPORT</md-button> -->

        <md-button
          v-show="showButtonTemplate"
          class="md-raised md-primary -flex"
          style="background-color: #d84710;"
          @click="onClickExportTemplateCSV()"
        >
          <md-icon style="font-size: 18px !important;">file_download</md-icon>
          <div style="padding-top: 5px; padding-left: 5px; padding-right: 5px;">
            Export
          </div>
        </md-button>
        <md-button
          v-show="showButtonTemplate"
          class="md-raised md-primary -flex"
          @click="onClickImportTemplateCSV()"
        >
          <md-icon style="font-size: 18px !important;">upload_file</md-icon>
          <div style="padding-top: 5px; padding-left: 5px; padding-right: 5px;">
            Import
          </div>
        </md-button>
        <input id="uploadcsv" ref="fileupload" type="file" hidden />
      </div>
    </div>

    <!-- BLOCK TABLE -->
    <div class="md-layout -block table-request-price" style="padding-top: 0px;">
      <!-- HEAD -->
      <div class="divHeadList">
        <div style="width: 4%;">
          <label class="-mkt-checkbox-container">
            <input
              type="checkbox"
              v-model="checkedProductAll"
              @click="selectedCheckedAllProduct()"
            />
            <span class="-mkt-checkbox"></span>
          </label>
        </div>
        <div style="width: 6%;">Code</div>
        <div :style="styleColumn()">Itme Name</div>
        <div style="width: 8%;" class="-text-right">Cost</div>
        <div v-show="radioType !== ''" style="width: 8%;" class="-text-right">
          {{ radioType === "typeA3" ? "A3" : "SS" }}
        </div>
        <!-- <div style="width: 8%;" class="-text-right">SS</div> -->
        <div style="width: 11%;" class="-text-right">Price Old</div>
        <div style="width: 11%;" class="-text-right">Request Price</div>
        <!-- <div style="width: 8%;" class="-text-right">Change</div> -->
        <div
          style="width: 8%; cursor: context-menu;"
          v-show="customer1 !== ''"
          class="-text-right"
          :title="labelTitle(customer1, customer1Title)"
        >
          {{ customer1 }}
        </div>
        <div
          style="width: 8%; cursor: context-menu;"
          v-show="customer2 !== ''"
          class="-text-right"
          :title="labelTitle(customer2, customer2Title)"
        >
          {{ customer2 }}
        </div>
        <div
          style="width: 8%; cursor: context-menu;"
          v-show="customer3 !== ''"
          class="-text-right"
          :title="labelTitle(customer3, customer3Title)"
        >
          {{ customer3 }}
        </div>
      </div>

      <!-- BODY -->
      <div
        :class="
          status === 'Draft' || status === '' || status === 'Return'
            ? 'divBodyList'
            : 'divBodyList calheight'
        "
      >
        <div
          v-show="tableRequestPrice.length === 0"
          :class="'row-bg-gray'"
          style="display: block; text-align: center; font-size: 14px;"
        >
          No data in table.
        </div>

        <div
          :class="'row-bg-gray'"
          v-for="(item, rIndex) in tableRequestPrice"
          :key="rIndex"
        >
          <div style="width: 4%;">
            <label class="-mkt-checkbox-container">
              <input
                type="checkbox"
                v-model="checkedProduct"
                :value="item.code"
                @click="selectedCheckedProduct(item.code)"
              />
              <span class="-mkt-checkbox"></span>
            </label>
          </div>
          <div style="width: 6%;">{{ item.code }}</div>
          <div
            :style="styleColumn()"
            class="nowrap-title -font-kanit"
            :title="item.title_th"
          >
            {{ item.title_th }}
          </div>
          <div style="width: 8%;" class="-text-right">
            <div v-show="showCost == 'true'" class="main-row">
              {{ formatNumber(item.cost, 2) }}
            </div>
          </div>
          <div v-show="radioType !== ''" style="width: 8%;" class="-text-right">
            <div class="main-row">
              {{
                radioType === "typeA3"
                  ? formatNumber(item.A3, 2)
                  : formatNumber(item.SS, 2)
              }}
            </div>
          </div>
          <!-- <div style="width: 8%;" class="-text-right">
            <div class="main-row">{{ formatNumber(item.SS, 2) }}</div>
          </div> -->
          <div style="width: 11%;" class="-text-right">
            <div class="main-row">
              {{ formatNumber(item.price_old, 2) }}
            </div>
            <div :class="setStylePercent(item, 'priceold')">
              {{ calPercent(item, "priceold") }}%
            </div>
          </div>
          <div style="width: 11%;" class="-text-right">
            <div class="main-row">
              {{ formatNumber(item.price_book, 2) }}
            </div>
            <div :class="setStylePercent(item, 'research')">
              {{ calPercent(item, "research") }}%
            </div>
          </div>
          <!-- <div style="width: 8%;" class="-text-right">
            <div class="main-row">{{ formatNumber(item.price_change, 2) }}</div>
            <div class="-blue">{{ calPercent(item, "change") }}%</div>
          </div> -->
          <div style="width: 8%;" class="-text-right" v-show="customer1 !== ''">
            <div class="main-row">{{ formatNumber(item.compare_cus1, 2) }}</div>
            <div :class="setStylePercent(item, 'compare_cus1')">
              {{ calPercent(item, "compare_cus1") }}%
            </div>
          </div>
          <div style="width: 8%;" class="-text-right" v-show="customer2 !== ''">
            <div class="main-row">{{ formatNumber(item.compare_cus2, 2) }}</div>
            <div :class="setStylePercent(item, 'compare_cus2')">
              {{ calPercent(item, "compare_cus2") }}%
            </div>
          </div>
          <div style="width: 8%;" class="-text-right" v-show="customer3 !== ''">
            <div class="main-row">{{ formatNumber(item.compare_cus3, 2) }}</div>
            <div :class="setStylePercent(item, 'compare_cus3')">
              {{ calPercent(item, "compare_cus3") }}%
            </div>
          </div>
        </div>
      </div>

      <!-- FOOTER -->
      <!-- <div class="footer-table">
        number of lines in page ({{ tableRequestPrice.length }})
      </div>-->
    </div>

    <!-- ACTION -->
    <div class="md-layout" style="margin: 8px 10px;">
      <div
        class="md-layout-item md-size-20"
        style="display: flex; margin-top: 12px; cursor: pointer;"
        @click="cilckItemComment()"
      >
        <md-icon style="margin: 0px 8px;">message</md-icon>
        <div style="font-size: 14px; font-weight: 500; font-style: italic;">
          Select Item Comment
        </div>
      </div>
      <div class="md-layout-item md-size-15"></div>
      <div
        class="md-layout-item md-size-25"
        style="margin-top: 12px; font-style: italic;"
      >
        number of lines in page ({{ tableRequestPrice.length }})
      </div>

      <!-- BUTTON -->
      <div class="md-layout-item md-size-40 -action">
        <md-button
          style="font-weight: bold; font-size: 16px; color: #A8A8A8; margin-right: 20px;"
          @click="cancelReq()"
          >CANCEL</md-button
        >

        <md-button
          v-show="status === 'Draft' || status === '' || status === 'Return'"
          style="font-weight: bold; font-size: 16px; color: #3F51B5;"
          @click="saveDraft()"
          >SAVE</md-button
        >
        <!-- showButtonApprove || -->
        <md-button
          v-show="status === 'Draft' || status === '' || status === 'Return'"
          style="font-weight: bold; font-size: 16px; color: #3F51B5;"
          @click="onClickApprove()"
          >SUBMIT</md-button
        >
      </div>
    </div>

    <!-- SELECT ITEM COMMENT -->
    <div
      class="select-item-comment"
      :style="showDialogConfirm ? 'z-index: 5;' : 'z-index: 8;'"
      v-show="showItemComment"
    >
      <div class="md-layout">
        <div
          class="md-layout-item md-size-100"
          style="margin-bottom: 5px; font-size: 18px; font-weight: bold;"
        >
          Comment
        </div>
      </div>

      <!-- BLOCK SCROLL -->
      <div class="md-layout block-scroll">
        <template v-for="(data, dIndex) in dataComments">
          <div class="md-layout content" :key="dIndex">
            <!-- HEAD -->
            <div class="md-layout-item md-size-50 display-flex">
              <md-icon>account_box</md-icon>
              <div class="font-kanit" style="display: flex;">
                <div class="displayName">{{ data.user }} {{ data.code }}</div>
                <div
                  class="displayStatus"
                  :style="styleDisplayStatus(data.status)"
                >
                  {{
                    data.status === "wait_approve_pmd"
                      ? "Wait approve"
                      : data.status
                  }}
                </div>
              </div>
            </div>
            <div class="md-layout-item md-size-50 date">
              {{ formatDate(data.c_date) }} {{ formatDateLL(data.c_date) }}
            </div>

            <!-- COMMENT -->
            <div
              class="md-layout-item md-size-100 -head"
              style="white-space: pre-line;"
              v-for="(comments, cIndex) in data.comment"
              :key="cIndex"
            >
              {{ comments.detail }}
              <div
                class="md-layout-item md-size-100 -detail"
                v-for="(items, index) in comments.items"
                :key="index"
              >
                ITEM. [ {{ items }} ]
              </div>
            </div>
          </div>
        </template>

        <!-- HEAD -->
        <div v-show="this.replyComment" class="md-layout content">
          <div class="md-layout-item md-size-50 display-flex">
            <md-icon>account_box</md-icon>
            <div class="font-kanit displayName">{{ roleType }}</div>
          </div>
          <div class="md-layout-item md-size-50 date">
            {{ currentDate }}
          </div>
          <!-- COMMENT -->
          <div class="md-layout-item md-size-100 -textarea">
            <textarea
              v-model="valueComment"
              placeholder="Input comment"
            ></textarea>
          </div>
        </div>
      </div>

      <!-- ACTION BUTTON -->
      <div class="md-layout" style="margin: 8px 0;">
        <div class="md-layout-item md-size-100 -action">
          <md-button
            v-show="!this.replyComment"
            class="md-raised md-primary"
            style="background: #A59D9D;"
            @click="closeComment()"
            >CLOSE</md-button
          >
          <md-button
            v-show="this.replyComment"
            class="md-raised md-primary"
            style="background: #A59D9D;"
            @click="cancelComment()"
            >CANCEL</md-button
          >
          <md-button
            v-show="this.replyComment"
            class="md-raised md-primary"
            @click="onReplyComment()"
            >REPLY</md-button
          >
        </div>
      </div>
    </div>
    <div
      class="bg-backdrop"
      v-show="showItemComment && !showDialogConfirm"
    ></div>

    <!-- DIALOG ALEART SEARCH -->
    <md-dialog
      :md-active.sync="showDialogAlert"
      class="mkt-ops -main-font volumepricing bookprice dialog-alert"
      :md-click-outside-to-close="false"
    >
      <md-dialog-title>Alert Message</md-dialog-title>
      <div class="layout-dialog">
        <div class="dialog-content">
          <div style="font-weight: bold; width: 20%;">
            Lost product : &ensp;
          </div>
          <div style="width: 80%;" class="scrollbar">{{ alertProductLost }}</div>
        </div>
        <div class="dialog-content -conditions" style="width: 92%;">
          <div class="title" style="width: 100%;">Check conditions</div>
          <div style="width: 100%;">
            <ul>
              <li>Product ที่มีสถานะเป็น Inactive จะไม่นำมาแสดง</li>
              <li>
                Product ที่มี Product Lift Cycle นอกจากที่กำหนดไว้ จะไม่นำมาแสดง
              </li>
              <li>Product ที่ไม่มีการตั้งราคา A3 ไว้ จะไม่นำมาแสดง</li>
              <li>
                Product ที่ไม่มีการตั้งราคา SS ไว้ จะไม่ทำมาแสดง
                (สินค้าที่สร้างให้ลูกค้ากลุ่ม MT)
              </li>
              <li>
                มีรายการ Product ที่อยู่ระหว่างการทำราคาภายใต้ book code
                เดียวกัน
              </li>
              <li>
                Product ที่มี Item Group = BM3 : Materials Product Pur. (Local)
                และ BM5 : Materials Product Pur (Import) จะไม่นำมาแสดง
              </li>
            </ul>
          </div>
        </div>
      </div>
      <md-dialog-actions class="-action">
        <md-button class="md-primary -confirm" @click="showDialogAlert = false"
          >OK</md-button
        >
      </md-dialog-actions>
    </md-dialog>

    <!-- DIALOG ALEART IMPORT -->
    <md-dialog
      :md-active.sync="showMsgImport"
      class="pricinglist dialog-import -message"
      :md-click-outside-to-close="false"
    >
      <md-dialog-title style="color:red; margin-bottom: 10px;"
        >Message Dialog</md-dialog-title
      >
      <ul
        v-for="(error, errorIndex) in listError"
        :key="errorIndex"
        style="padding-left: 60px; margin-top: 10px; margin-bottom: 10px;"
      >
        <li>{{ error }}</li>
      </ul>
      <md-dialog-actions class="-action -error">
        <md-button
          class="md-primary -cancel"
          @click="showMsgImport = false"
          style="font-weight: bold;"
          >OK</md-button
        >
      </md-dialog-actions>
    </md-dialog>

    <!-- DIALOG REJECT -->
    <md-dialog
      :md-active.sync="showDialogMemo"
      :md-click-outside-to-close="false"
      class="promo-memo"
    >
      <md-dialog-title>
        Are you sure you want to return ?
      </md-dialog-title>

      <div class="layout-dialog">
        <textarea
          v-model="memoComment"
          placeholder="Please enter the reason."
        ></textarea>
      </div>

      <md-dialog-actions class="-action">
        <md-button class="md-primary -cancel" @click="showDialogMemo = false"
          >CLOSE</md-button
        >
        <md-button
          @click="onSaveMemo()"
          :style="disabledButton ? '' : 'color: #3F51B5;'"
          :disabled="disabledButton"
          >RETURN</md-button
        >
      </md-dialog-actions>
    </md-dialog>

    <!-- COMPONENTS -->
    <dialog-compare-customer
      :show="showDialogCompareCustomer"
      :customer="allCustomerBookPrice"
      :bookcode="compareBookPrice"
      @cancel="onClickCancelCompare"
      @addclose="onClickAddCloseCompare"
    ></dialog-compare-customer>

    <dialog-filter-product
      :show="showDialogFilterProduct"
      :bookpriceGroup="bookpriceGroup"
      :groupBookCode="groupBookCode"
      @cancel="onClickCancel"
      @add="onClickAdd"
      @addclose="onClickAddClose"
    ></dialog-filter-product>

    <dialog-confirm
      :show="showDialogConfirm"
      :content="contentDialog"
      :confirmText="confirmText"
      :cancelText="cancelText"
      @cancel="onCancel()"
      @confirm="onConfirm()"
    ></dialog-confirm>

    <dialog-import-file
      :show="showDialogImportFile"
      :data="dataListImport"
      @cancel="onClickCancelImport"
      @confirm="onClickComfirmImport"
    ></dialog-import-file>

    <md-snackbar
      :md-position="position"
      :md-duration="isInfinity ? Infinity : duration"
      :md-active.sync="showSnackbar"
      md-persistent
    >
      <span>{{ contentSnackbar }}</span>
      <md-button class="md-primary" @click="showSnackbar = false">OK</md-button>
    </md-snackbar>
  </div>
</template>

<script>
import GlobalService from "@/services/global_function";
import BookpriceService from "@/services/bookprice";
import DialogCompareCustomer from "./dialog-compare-customer";
import DialogFilterProduct from "./dialog-filter-product";
import DialogConfirm from "./../../shared/dialog-confirm";
import DialogImportFile from "./dialog-import-file";
import moment from "moment-timezone";
import Vue from "vue";

import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { ASYNC_SEARCH } from "@riophae/vue-treeselect";
const simulateAsyncOperation = fn => {
  setTimeout(fn, 2000);
};

export default {
  name: "request-price",

  components: {
    DialogCompareCustomer,
    DialogFilterProduct,
    DialogConfirm,
    Treeselect,
    DialogImportFile
  },

  watch: {
    effective_date() {
      if (
        this.$refs.effective_date !== undefined &&
        this.$refs.effective_date.$el.children[3] !== undefined
      ) {
        this.$refs.effective_date.$el.children[2].addEventListener(
          "click",
          this.clearEffectiveDate,
          false
        );
      }
    },
    expire_date() {
      if (
        this.$refs.expire_date !== undefined &&
        this.$refs.expire_date.$el.children[3] !== undefined
      ) {
        this.$refs.expire_date.$el.children[2].addEventListener(
          "click",
          this.clearExpireDate,
          false
        );
      }
    },
    memoComment() {
      if (this.memoComment.trim() !== "") {
        this.disabledButton = false;
      }
    }
  },

  data() {
    return {
      dataToken: {},
      userActivity: [],
      rowRequestPrice: [],
      bookCode: "",
      docNo: "",
      effective_date: null,
      expire_date: null,
      desc: "",
      c_date: "",
      status: "",
      radioType: "",
      bookpriceGroup: "",
      groupBookCode: "",
      valueSearchProduct: "",
      tableRequestPrice: [],
      checkedProductAll: false,
      checkedProduct: [],
      valueComment: "",
      showItemComment: false,
      showDialogCompareCustomer: false,
      showDialogFilterProduct: false,
      valueTree: [],
      optionsTreeview: [],
      valueConsistsOf: "LEAF_PRIORITY",
      checkEvent: "",
      showDialogConfirm: false,
      contentDialog: "",
      confirmText: "OK",
      cancelText: "CANCEL",
      loading: false,
      showSnackbar: false,
      position: "center",
      duration: 20000,
      isInfinity: false,
      contentSnackbar: "",
      disabledEffDates: date => {
        return date < moment().add(-1, "days");
      },
      disabledExpDates: date => {
        return date < moment().add(-1, "days");
      },
      showDialogAlert: false,
      alertProductLost: "",
      showBackdrop: false,
      allCustomerBookPrice: [],
      customer1: "",
      customer1Title: "",
      customer2: "",
      customer2Title: "",
      customer3: "",
      customer3Title: "",
      dataCompareCustomer: [],
      showDialogImportFile: false,
      dataListImport: [],
      // showButtonSave: false,
      showButtonSendToApprove: false,
      showButtonApprove: false,
      showButtonReject: false,
      showIconFilterProduct: false,
      showIconCompareCustomer: false,
      showButtonTemplate: false,
      showButtonImportTemplate: false,
      dataComments: [],
      roleType: "",
      currentDate: "",
      replyComment: false,
      showMsgImport: false,
      listError: [],
      showDialogMemo: false,
      memoComment: "",
      disabledButton: true,
      compareBookPrice: [],
      checkDataDelete: [],
      afterExport: false,
      showCost: false
    };
  },

  async created() {
    this.dataToken = this.$jwt.decode(localStorage.getItem("token"));
    this.currentDate = moment(new Date()).format("LL");

    this.loading = true;
    await BookpriceService.getUserActivity({ emp_code: this.dataToken.code }).then(
      (response) => {
        localStorage.setItem("user_activity", JSON.stringify(response.data));
        localStorage.setItem("show_cost", response.data.show_cost);
        this.loading = false;
      }
    );

    this.showCost = localStorage.getItem("show_cost");

    this.rowRequestPrice = JSON.parse(
      localStorage.getItem("row_request_price")
    );

    if (this.rowRequestPrice.bookprice_group === "MTT") {
      this.radioType = "typeA3";
    } else if (this.rowRequestPrice.bookprice_group === "MT") {
      this.radioType = "typeSS";
    } else {
      this.radioType = "";
    }
    this.bookpriceGroup = this.rowRequestPrice.bookprice_group;
    this.groupBookCode = this.rowRequestPrice.code;

    this.status = this.rowRequestPrice.status;
    this.roleType =
      this.dataToken.firstname +
      " " +
      this.dataToken.lastname +
      " " +
      this.dataToken.code;

    /* View Comment */
    let name = this.dataToken.firstname + " " + this.dataToken.lastname;
    if (
      this.rowRequestPrice.holder_by === name ||
      this.status === "" ||
      this.status === "Draft"
    ) {
      this.replyComment = true;
    }
    /* View Comment */

    /* START Check Button */
    // console.log("- 2 -");
    this.userActivity = JSON.parse(localStorage.getItem("user_activity"));
    // END - Check Button Template, Import Template

    if (
      this.userActivity.role_type === "SALE_CO" &&
      (this.status === "Draft" ||
        this.status === "" ||
        this.status === "Return")
    ) {
      this.showIconFilterProduct = true;
      this.showIconCompareCustomer = true;

      this.showButtonTemplate = true;
      this.showButtonImportTemplate = true;
    } else if (this.userActivity.role_type === "SALE_MG") {
      this.showIconFilterProduct = false;
      this.showIconCompareCustomer = false;

      this.showButtonTemplate = false;
      this.showButtonImportTemplate = false;
    } else if (this.userActivity.role_type === "PMD_MG") {
      this.showIconFilterProduct = false;
      this.showIconCompareCustomer = true;

      this.showButtonTemplate = false;
      this.showButtonImportTemplate = false;
    }

    BookpriceService.getGroupBookMaster().then(response => {
      response.sort((a, b) => (a.id > b.id ? 1 : -1));
      this.allCustomerBookPrice = response;
    });
    //-- END GET ALL CUSTOMER IN BOOOK PRICE --//

    this.bookCode = this.rowRequestPrice.code;
    this.docNo = this.rowRequestPrice.doc_no;
    this.desc = this.rowRequestPrice.desc;
    // this.status = this.rowRequestPrice.status;
    this.effective_date = null;
    this.expire_date = null;
    // this.c_date = "";
    // this.c_date = moment(new Date(this.rowRequestPrice.c_date)).format(
    //   "DD-MM-YYYY"
    // );
    this.$material.locale.dateFormat = "dd-MM-yyyy";

    if (this.rowRequestPrice.tab === "REQUEST_PRICE") {
      this.loading = true;
      this.c_date = moment(new Date(this.rowRequestPrice.c_date)).format(
        "DD-MM-YYYY"
      );

      let datas = {
        bookcode: this.bookCode,
        id: this.rowRequestPrice._id,
        emp_code: this.dataToken.code
      };
      BookpriceService.getListRequestPrice(datas)
        .then(response => {
          if (response.bookprice_group === "MTT") {
            this.radioType = "typeA3";
          } else if (response.bookprice_group === "MT") {
            this.radioType = "typeSS";
          } else {
            this.radioType = "";
          }

          // this.bookpriceGroup = response.bookprice_group;
          if (response.product.length > 0) {
            response.product.sort((a, b) => (a.code > b.code ? 1 : -1));
            // this.disabledExpDates = date => {
            //   return date < moment(this.effective_date, "DD-MM-YYYY");
            // };

            if (
              response.product[0].effective_date === "" ||
              response.product[0].effective_date === "Invalid date"
            ) {
              this.effective_date = null;
            } else {
              this.effective_date = moment(
                new Date(response.product[0].effective_date)
              ).format("DD-MM-YYYY");
            }

            if (
              response.product[0].expire_date === "" ||
              response.product[0].expire_date === "Invalid date"
            ) {
              this.expire_date = null;
            } else {
              this.expire_date = moment(
                new Date(response.product[0].expire_date)
              ).format("DD-MM-YYYY");
            }

            // this.c_date = moment(new Date(response.product[0].ctime)).format(
            //   "DD-MM-YYYY"
            // );

            for (let i = 0; i < response.product.length; i++) {
              this.valueTree.push(response.product[i].code);
              this.tableRequestPrice.push({
                code: response.product[i].code,
                title_th: response.product[i].title_th,
                cost: response.product[i].cost,
                A3:
                  response.product[i].selling_conv_price &&
                  response.product[i].selling_conv_price.A3 !== undefined
                    ? response.product[i].selling_conv_price.A3
                    : "",
                SS:
                  response.product[i].selling_conv_price &&
                  response.product[i].selling_conv_price.SS !== undefined
                    ? response.product[i].selling_conv_price.SS
                    : "",
                SR:
                  response.product[i].selling_conv_price &&
                  response.product[i].selling_conv_price.SR !== undefined
                    ? response.product[i].selling_conv_price.SR
                    : "",
                price_old: response.product[i].price_old
                  ? response.product[i].price_old
                  : "",
                price_book: response.product[i].price_book
                  ? response.product[i].price_book
                  : ""
              });
            }

            if (response.compare !== null && response.compare.length > 0) {
              let dataSearch = [];
              // for (let i = 0; i < response.compare.length; i++) {
              //   dataSearch.push({
              //     id: response.compare[i]
              //   });
              // }

              dataSearch = response.compare;
              this.onClickAddCloseCompare(dataSearch);
            }
          }
          if (response.compare.length > 0) {
            this.compareBookPrice = response.compare;
          }
          this.loading = false;
        })
        .catch(error => {
          if (error.response) {
            if (error.response.status == "404") {
              this.tableRequestPrice = [];
              this.contentSnackbar = error.response.data.message;
              this.showSnackbar = true;
              this.loading = false;
              return;
            } else {
              this.tableRequestPrice = [];
              this.contentSnackbar = error.response.data.errors.title;
              this.showSnackbar = true;
              this.loading = false;
              return;
            }
          }
        });
    } else {
      this.tableRequestPrice = [];
      this.c_date = moment(new Date()).format("DD-MM-YYYY");
    }
  },

  methods: {
    clearEffectiveDate() {
      this.effective_date = null;
    },
    clearExpireDate() {
      this.expire_date = null;
    },
    formatNumber(value, dicimal) {
      return GlobalService.formatNumber(value, dicimal);
    },
    formatDate(date) {
      return GlobalService.formatDate(date, "HH:mm");
    },
    formatDateLL(date) {
      return GlobalService.formatDate(date, "LL");
    },
    labelTitle(customer, title) {
      return customer + " : " + title;
    },
    styleColumn() {
      let width = "";
      if (
        this.customer1 !== "" &&
        this.customer2 !== "" &&
        this.customer3 !== ""
      ) {
        // return "width: 39%;";
        width = 28;
      } else if (
        this.customer1 === "" &&
        this.customer2 === "" &&
        this.customer3 === ""
      ) {
        // return "width: 63%;";
        width = 52;
      } else if (this.customer1 !== "" && this.customer2 !== "") {
        // return "width: 47%;";
        width = 36;
      } else if (this.customer1 !== "") {
        // return "width: 55%;";
        width = 44;
      }

      if (this.radioType === "") {
        width += 8;
      }

      return "width: " + width + "%;";
    },
    styleDisplayStatus(status) {
      if (status === "Wait approve" || status === "wait_approve_pmd") {
        return "background-color: #fbc02d";
      } else if (status === "Draft") {
        return "background-color: #767676";
      } else if (status === "Approve") {
        return "background-color: #64a064";
      } else if (status === "Return") {
        return "background-color: red";
      }
    },
    loadOptions({ action, searchQuery, callback }) {
      let self = this;
      let emp_code = this.$jwt.decode(localStorage.getItem("token")).code;
      let dataSearch = {
        name: "",
        type: "",
        group: "",
        subgroup: "",
        cg: ""
      };

      let codeSearch = searchQuery.trim() !== "" ? searchQuery : "";
      let splitText = codeSearch.split(" ");
      let texts = "";
      splitText.forEach(function(value) {
        texts += value + ",";
      });
      let text = texts.substring(0, texts.length - 1);

      if (action === ASYNC_SEARCH && searchQuery.trim() !== "") {
        if (searchQuery.trim().length > 5) {
          simulateAsyncOperation(() => {
            BookpriceService.searchProduct(
              text,
              "paste",
              this.checkDataDelete,
              emp_code,
              dataSearch,
              this.bookpriceGroup,
              self.bookCode
            )
              .then(response => {
                if (response) {
                  self.optionsTreeview = response.data;
                  self.setDataTable(response.data);

                  if (response.message.length > 0) {
                    self.alertProductLost = "";
                    let length = response.message.length - 1;
                    response.message.forEach(function(value, key) {
                      self.alertProductLost +=
                        key == length ? value : value + ", ";
                    });
                    self.showDialogAlert = true;
                  }

                  if (self.optionsTreeview.length >= 1) {
                    let input_search = self.$refs.productTxt;
                    let real_input = input_search.$el.querySelector(
                      ".vue-treeselect__input"
                    );
                    real_input.value = "";
                  }

                  callback(null, self.optionsTreeview);
                }
              })
              .catch();
          });
        } else {
          callback(null, []);
        }
      }
    },
    loadOptions2({ action, searchQuery, callback }) {
      let self = this;
      let emp_code = this.$jwt.decode(localStorage.getItem("token")).code;
      let dataSearch = {
        name: "",
        type: "",
        group: "",
        subgroup: "",
        cg: ""
      };

      let codeSearch = searchQuery.trim() !== "" ? searchQuery : "";
      let splitText = codeSearch.split(" ");
      let texts = "";
      splitText.forEach(function(value) {
        texts += value + ",";
      });
      let text = texts.substring(0, texts.length - 1);

      if (action === ASYNC_SEARCH && searchQuery.trim() !== "") {
        if (searchQuery.trim().length > 5) {
          simulateAsyncOperation(() => {
            BookpriceService.searchProduct2(
              text,
              "paste",
              this.checkDataDelete,
              emp_code,
              dataSearch,
              this.bookpriceGroup,
              self.bookCode
            )
              .then(response => {
                if (response) {
                  self.optionsTreeview = response.data;
                  self.setDataTable(response.data);

                  if (response.message.length > 0) {
                    self.alertProductLost = "";
                    let length = response.message.length - 1;
                    response.message.forEach(function(value, key) {
                      self.alertProductLost +=
                        key == length ? value : value + ", ";
                    });
                    self.showDialogAlert = true;
                  }

                  if (self.optionsTreeview.length >= 1) {
                    let input_search = self.$refs.productTxt2;
                    let real_input = input_search.$el.querySelector(
                      ".vue-treeselect__input"
                    );
                    real_input.value = "";
                  }

                  callback(null, self.optionsTreeview);
                }
              })
              .catch();
          });
        } else {
          callback(null, []);
        }
      }
    },
    setDataTable(data) {
      let self = this;
      if (data.length > 0) {
        data.forEach(function(value) {
          let key = self.valueTree
            .map(function(e) {
              return e;
            })
            .indexOf(value.id);

          if (key === -1) {
            self.valueTree.push(value.id);

            self.tableRequestPrice.push({
              code: value.code,
              title_th: value.item_name,
              cost: value.cost,
              A3:
                value.price && value.price.A3 !== undefined
                  ? value.price.A3
                  : "",
              SS:
                value.price && value.price.SS !== undefined
                  ? value.price.SS
                  : "",
              SR:
                value.price && value.price.SR !== undefined
                  ? value.price.SR
                  : "",
              price_old: value.price_old ? value.price_old : "",
              price_book: value.price_book ? value.price_book : ""
            });
          }
        });
        self.loadDatacompareCustomer();
      }
    },
    setDataTablePopup(data) {
      let self = this;
      if (data.length > 0) {
        data.forEach(function(value) {
          let key = self.tableRequestPrice.findIndex(item => {
            return value.code === item.code;
          });

          if (key === -1) {
            self.valueTree.push(value.code);

            self.tableRequestPrice.push({
              code: value.code,
              title_th: value.item_name,
              cost: value.cost,
              A3:
                value.price && value.price.A3 !== undefined
                  ? value.price.A3
                  : "",
              SS:
                value.price && value.price.SS !== undefined
                  ? value.price.SS
                  : "",
              SR:
                value.price && value.price.SR !== undefined
                  ? value.price.SR
                  : "",
              price_old: value.price_old ? value.price_old : "",
              price_book: value.price_book ? value.price_book : ""
            });
          }
        });

        this.loadDatacompareCustomer();
      }
    },
    OnSelectTreeview(node) {
      let data = [];
      data.push(node);
      this.setDataTable(data);
    },
    onDeSelectTreeview(node) {
      let key = this.tableRequestPrice.findIndex(item => {
        return node.id === item.code;
      });
      if (key > -1) {
        this.tableRequestPrice.splice(key, 1);
      }
    },
    OnSelectTreeview2(node) {
      let data = [];
      data.push(node);
      this.setDataTable(data);
    },
    onDeSelectTreeview2(node) {
      let key = this.tableRequestPrice.findIndex(item => {
        return node.id === item.code;
      });
      if (key > -1) {
        this.tableRequestPrice.splice(key, 1);
      }
    },
    deleteItems() {
      if (this.checkedProduct.length === 0) {
        this.contentSnackbar = "Please select data.";
        this.showSnackbar = true;
        return;
      }

      this.checkEvent = "delete";
      this.contentDialog = "Are you sure you want to delete ?";
      this.confirmText = "OK";
      this.cancelText = "CANCEL";
      this.showDialogConfirm = true;
    },
    selectedCheckedAllProduct() {
      this.checkedProduct = [];
      if (!this.checkedProductAll) {
        for (let itemCode in this.tableRequestPrice) {
          this.checkedProduct.push(this.tableRequestPrice[itemCode].code);
        }
      }
    },
    selectedCheckedProduct(code) {
      if (this.checkedProduct.indexOf(code) == -1) {
        this.checkedProduct.push(code);
      } else {
        this.checkedProduct.splice(this.checkedProduct.indexOf(code), 1);
      }

      if (this.checkedProduct.length !== this.tableRequestPrice.length) {
        this.checkedProductAll = false;
      } else {
        this.checkedProductAll = true;
      }
    },
    setStylePercent(data, type) {
      let value = this.calPercent(data, type);
      if (parseFloat(value) >= 0) {
        return "-blue";
      } else {
        return "-red";
      }
    },
    calPercent(data, type) {
      if (type === "research") {
        let research =
          data.price_book && data.price_book !== "" ? data.price_book : 0;
        let A3 = data.A3 && data.A3 !== "" ? data.A3 : 0;
        let SS = data.SS && data.SS !== "" ? data.SS : 0;
        let part = this.radioType === "typeA3" ? A3 : SS;
        return research === 0 || part === 0
          ? 0
          : this.formatNumber(
              ((parseFloat(research) - parseFloat(part)) / parseFloat(part)) *
                100,
              2
            );
      }else if (type === "priceold") {
        let priceold = data.price_old && data.price_old !== "" ? data.price_old : 0;
        let A3 = data.A3 && data.A3 !== "" ? data.A3 : 0;
        let SS = data.SS && data.SS !== "" ? data.SS : 0;
        let part = this.radioType === "typeA3" ? A3 : SS;
        return priceold === 0 || part === 0
          ? 0
          : this.formatNumber(
              ((parseFloat(priceold) - parseFloat(part)) / parseFloat(part)) *
                100,
              2
            );
      } else if (type === "change") {
        let change =
          data.price_change && data.price_change !== "" ? data.price_change : 0;
        let A3 = data.A3 && data.A3 !== "" ? data.A3 : 0;
        let SS = data.SS && data.SS !== "" ? data.SS : 0;
        let part = this.radioType === "typeA3" ? A3 : SS;
        return change === 0 || part === 0
          ? 0
          : this.formatNumber(
              ((parseFloat(change) - parseFloat(part)) / parseFloat(part)) *
                100,
              2
            );
      } else if (type === "compare_cus1") {
        let compareCus1 =
          data.compare_cus1 && data.compare_cus1 !== "" ? data.compare_cus1 : 0;
        let A3 = data.A3 && data.A3 !== "" ? data.A3 : 0;
        let SS = data.SS && data.SS !== "" ? data.SS : 0;
        let part = this.radioType === "typeA3" ? A3 : SS;
        return compareCus1 === 0 || part === 0
          ? 0
          : this.formatNumber(
              ((parseFloat(compareCus1) - parseFloat(part)) /
                parseFloat(part)) *
                100,
              2
            );
      } else if (type === "compare_cus2") {
        let compareCus2 =
          data.compare_cus2 && data.compare_cus2 !== "" ? data.compare_cus2 : 0;
        let A3 = data.A3 && data.A3 !== "" ? data.A3 : 0;
        let SS = data.SS && data.SS !== "" ? data.SS : 0;
        let part = this.radioType === "typeA3" ? A3 : SS;
        return compareCus2 === 0 || part === 0
          ? 0
          : this.formatNumber(
              ((parseFloat(compareCus2) - parseFloat(part)) /
                parseFloat(part)) *
                100,
              2
            );
      } else if (type === "compare_cus3") {
        let compareCus3 =
          data.compare_cus3 && data.compare_cus3 !== "" ? data.compare_cus3 : 0;
        let A3 = data.A3 && data.A3 !== "" ? data.A3 : 0;
        let SS = data.SS && data.SS !== "" ? data.SS : 0;
        let part = this.radioType === "typeA3" ? A3 : SS;
        return compareCus3 === 0 || part === 0
          ? 0
          : this.formatNumber(
              ((parseFloat(compareCus3) - parseFloat(part)) /
                parseFloat(part)) *
                100,
              2
            );
      }
    },
    cancelReq() {
      this.checkEvent = "cancel";
      this.contentDialog = "Are you sure you want to cancel ?";
      this.confirmText = "OK";
      this.cancelText = "CANCEL";
      this.showDialogConfirm = true;
    },
    saveDraft() {
      this.checkEvent = "savedraft";
      let check = this.checkCondition();
      if (check) {
        this.contentDialog = "Are you sure you want to save draft ?";
        this.confirmText = "OK";
        this.cancelText = "CANCEL";
        this.showDialogConfirm = true;
      }
    },
    onClickApprove() {
      this.checkEvent = "approve";
      let check = this.checkCondition();
      if (check) {
        this.contentDialog = "Are you sure you want to approve?";
        this.confirmText = "OK";
        this.cancelText = "CANCEL";
        this.showDialogConfirm = true;
      }
    },
    checkCondition() {
      if (
        // this.checkEvent === "sendtoapprove" &&
        this.checkEvent === "approve" &&
        (this.effective_date === null || this.effective_date === "")
      ) {
        this.contentSnackbar = "Please select effective date.";
        this.showSnackbar = true;
        return false;
      }
      if (this.tableRequestPrice.length === 0) {
        this.contentSnackbar = "Please select products in group.";
        this.showSnackbar = true;
        return false;
      }

      /* START CHECK Research Price */
      let checkRqPriceNull = false;
      for (let i = 0; i < this.tableRequestPrice.length; i++) {
        if (
          this.tableRequestPrice[i].price_book === null ||
          this.tableRequestPrice[i].price_book === ""
        ) {
          checkRqPriceNull = true;
          continue;
          // return;
        }
      }

      // if (this.checkEvent === "sendtoapprove" && checkRqPriceNull) {
      if (this.checkEvent === "approve" && checkRqPriceNull) {
        this.contentSnackbar = "Research Price is null.";
        this.showSnackbar = true;
        return false;
      } else {
        return true;
      }
      /* END CHECK Research Price */
    },
    cilckItemComment() {
      BookpriceService.getComment({ id: this.rowRequestPrice._id }).then(
        response => {
          if (response.data) {
            this.dataComments = response.data;
          }
          this.showItemComment = this.showItemComment ? false : true;
        }
      );
    },
    closeComment() {
      this.checkEvent = "close_comment";
      this.contentDialog = "Are you sure you want to close comment ?";
      this.confirmText = "OK";
      this.cancelText = "CANCEL";
      this.showDialogConfirm = true;
    },
    cancelComment() {
      this.checkEvent = "cancel_comment";
      this.contentDialog = "Are you sure you want to cancel comment ?";
      this.confirmText = "OK";
      this.cancelText = "CANCEL";
      this.showDialogConfirm = true;
    },
    onReplyComment() {
      this.checkEvent = "reply_comment";
      this.contentDialog = "Are you sure you want to reply comment ?";
      this.confirmText = "OK";
      this.cancelText = "CANCEL";
      this.showDialogConfirm = true;
    },
    compareCustomer() {
      this.showDialogCompareCustomer = true;
    },
    filterProduct() {
      this.showDialogFilterProduct = true;
    },
    onClickAdd(dataArray) {
      this.setDataTablePopup(dataArray);
    },
    onClickAddClose(dataArray) {
      this.setDataTablePopup(dataArray);
      this.showDialogFilterProduct = false;
    },
    onClickCancel() {
      this.showDialogFilterProduct = false;
    },
    onClickCancelCompare() {
      this.showDialogCompareCustomer = false;
    },
    onClickAddCloseCompare(dataSearch) {
      this.dataCompareCustomer = dataSearch;
      this.customer1 =
        this.dataCompareCustomer[0] &&
        this.dataCompareCustomer[0].id &&
        this.dataCompareCustomer[0].id !== ""
          ? this.dataCompareCustomer[0].id
          : "";
      this.customer1Title =
        this.dataCompareCustomer[0] &&
        this.dataCompareCustomer[0].label &&
        this.dataCompareCustomer[0].label !== ""
          ? this.dataCompareCustomer[0].label
          : "";
      this.customer2 =
        this.dataCompareCustomer[1] &&
        this.dataCompareCustomer[1].id &&
        this.dataCompareCustomer[1].id !== ""
          ? this.dataCompareCustomer[1].id
          : "";
      this.customer2Title =
        this.dataCompareCustomer[1] &&
        this.dataCompareCustomer[1].label &&
        this.dataCompareCustomer[1].label !== ""
          ? this.dataCompareCustomer[1].label
          : "";
      this.customer3 =
        this.dataCompareCustomer[2] &&
        this.dataCompareCustomer[2].id &&
        this.dataCompareCustomer[2].id !== ""
          ? this.dataCompareCustomer[2].id
          : "";
      this.customer3Title =
        this.dataCompareCustomer[2] &&
        this.dataCompareCustomer[2].label &&
        this.dataCompareCustomer[2].label !== ""
          ? this.dataCompareCustomer[2].label
          : "";

      this.compareBookPrice = [];
      this.compareBookPrice = this.dataCompareCustomer;

      this.loadDatacompareCustomer();
      this.showDialogCompareCustomer = false;
    },
    loadDatacompareCustomer() {
      let code = [];
      let customerCompare = [];
      if (this.dataCompareCustomer.length > 0) {
        this.dataCompareCustomer.forEach(function(item) {
          if (item.id !== undefined) {
            customerCompare.push(item.id);
          }
        });
      }

      for (let i = 0; i < this.tableRequestPrice.length; i++) {
        code.push(this.tableRequestPrice[i].code);
      }

      let datas = {
        customer: customerCompare,
        code: code
      };

      BookpriceService.compareCustomer(datas).then(response => {
        // console.log("response ==>", response.data);
        if (response.data) {
          for (let i = 0; i < this.tableRequestPrice.length; i++) {
            let valueCus1 =
              this.dataCompareCustomer[0] && this.dataCompareCustomer[0] !== ""
                ? response.data[i][this.dataCompareCustomer[0].id]
                : "";
            Vue.set(this.tableRequestPrice[i], "compare_cus1", valueCus1);

            let valueCus2 =
              this.dataCompareCustomer[1] && this.dataCompareCustomer[1] !== ""
                ? response.data[i][this.dataCompareCustomer[1].id]
                : "";
            Vue.set(this.tableRequestPrice[i], "compare_cus2", valueCus2);

            let valueCus3 =
              this.dataCompareCustomer[2] && this.dataCompareCustomer[2] !== ""
                ? response.data[i][this.dataCompareCustomer[2].id]
                : "";
            Vue.set(this.tableRequestPrice[i], "compare_cus3", valueCus3);
          }
        }
      });
    },
    saveRequestPrice(stay = false) {
      let effectiveDate = this.effective_date
        ? moment(this.effective_date, "DD-MM-YYYY").format(
            "YYYY-MM-DD HH:mm:ss"
          )
        : "";
      let expireDate = this.expire_date
        ? moment(this.expire_date, "DD-MM-YYYY").format("YYYY-MM-DD HH:mm:ss")
        : "";
      let requestDate = this.c_date
        ? moment(this.c_date, "DD-MM-YYYY").format("YYYY-MM-DD HH:mm:ss")
        : "";

      let mode = "";
      if (this.checkEvent === "savedraft") {
        mode = "Draft";
      } else if (
        this.checkEvent === "sendtoapprove" ||
        this.checkEvent === "approve"
      ) {
        mode = "Wait approve";
      } else if (this.checkEvent === "reject") {
        mode = "Return";
      }

      let customerCompare = [];
      this.dataCompareCustomer.forEach(function(item) {
        if (item.id !== undefined) {
          customerCompare.push(item.id);
        }
      });

      let dataHead = {
        emp_code: this.dataToken.code,
        bookcode: this.bookCode,
        desc: this.desc,
        effective_date: effectiveDate,
        expire_date: expireDate,
        request_date: requestDate,
        price_type: "A3",
        mode: mode,
        new: this.rowRequestPrice.tab === "REQUEST_PRICE" ? false : true,
        id: this.rowRequestPrice._id,
        postexport: this.afterExport,
        compare: customerCompare
      };

      let dataSave = {
        head: dataHead,
        product: this.tableRequestPrice
      };

      BookpriceService.saveRequestPrice(dataSave).then(response => {
        this.loading = false;
        let tmp = response;
        if(response.status == true && response.data !== undefined){
            let oldRequest = this.rowRequestPrice;
            let rowrequest = response.data;
            rowrequest.tab = 'REQUEST_PRICE';
            rowrequest.bookprice_group = oldRequest.bookprice_group; 
            rowrequest.sum_cust = oldRequest.sum_cust; 
            
            localStorage.setItem('row_request_price', JSON.stringify(rowrequest))
            this.afterExport = false;
        }
        if(stay){
            this.$router.go();
        }else{
            this.$router.push("/overview/book-price");
        }
      });
    },
    onConfirm() {
      if (this.checkEvent === "delete") {
        for (let i = 0; i < this.checkedProduct.length; i++) {
          this.checkDataDelete.push(this.checkedProduct[i]);

          let key = this.tableRequestPrice.findIndex(item => {
            return this.checkedProduct[i] === item.code;
          });
          this.tableRequestPrice.splice(key, 1);

          let index = this.valueTree.indexOf(this.checkedProduct[i]);
          this.valueTree.splice(index, 1);
        }
        this.clearData();
      } else if (this.checkEvent === "cancel") {
        this.checkDataDelete = [];
        this.showDialogConfirm = false;
        localStorage.removeItem("row_request_price");
        this.$store.commit("bookprice/onClickRequestPage", false);
        this.$router.push("/overview/book-price");
        this.clearData();
      } else if (
        this.checkEvent === "savedraft" ||
        this.checkEvent === "sendtoapprove" ||
        this.checkEvent === "reject" ||
        this.checkEvent === "approve"
      ) {
        this.checkDataDelete = [];
        this.loading = true;
        this.saveRequestPrice();
        this.clearData();
        // localStorage.removeItem("row_request_price");
        // this.$router.push("/overview/book-price");
      } else if (
        this.checkEvent === "close_comment" ||
        this.checkEvent === "cancel_comment"
      ) {
        this.checkDataDelete = [];
        this.valueComment = "";
        this.showItemComment = false;
      } else if (this.checkEvent === "reply_comment") {
        this.checkDataDelete = [];
        this.saveComment(this.valueComment);
      }
      // this.clearData();
      this.showDialogConfirm = false;
    },
    saveComment(valueComment) {
      let datas = {
        data: {
          type: "comment",
          id: this.rowRequestPrice._id,
          attributes: {
            emp_code: this.dataToken.code,
            detail: valueComment
          }
        }
      };
      BookpriceService.replyComment(datas).then(response => {
        this.valueComment = "";
        this.showItemComment = false;
      });
    },
    clearData() {
      this.checkedProductAll = false;
      this.checkedProduct = [];
    },
    onCancel() {
      this.showDialogConfirm = false;
    },
    handleFiles(event) {
        var files = event.target.files;
        if (files.length > 0) {
            this.loading = true;
            this.showBackdrop = true;
//            this.nameFile = files[0].name;
            let fileTxt = this.$refs.fileupload.files;
            const file = fileTxt[0];
            let test = '';
            new FileReader
            let reader = new FileReader();
            var vm = this;
            reader.onload = (e) => {
                let explod = [];
                vm.test = reader.result;
                explod = vm.test.split("\n");
                let data_import = [];
                if(explod[3] !== undefined){
                    data_import = explod.slice(3);
                }else{
                    console.log('file import invalid.');
                    return;
                }
                let code = '';
                let newPrice = [];
                data_import.forEach(row => {
                    let item = row.split(',');
                    if(item[3] === undefined){ return; }
                    code = (item[3].substr(0,1) === "'")? item[3].substr(1) : item[3];
                    newPrice.push({
                        code: code,
                        title_th: item[4],
//                        cost: response.product[i].cost,
                        A3: item[6],
//                        SS:
//                            response.product[i].selling_conv_price &&
//                            response.product[i].selling_conv_price.SS !== undefined
//                              ? response.product[i].selling_conv_price.SS
//                              : "",
//                        SR:
//                            response.product[i].selling_conv_price &&
//                            response.product[i].selling_conv_price.SR !== undefined
//                              ? response.product[i].selling_conv_price.SR
//                              : "",
//                        price_old: 88,
                        price_book: item[11]
                    });
                });
                if(newPrice.length > 0){
                    vm.tableRequestPrice = newPrice;
    //                vm.saveDraft();
                    vm.checkEvent = "savedraft";
                    vm.checkDataDelete = [];
                    vm.clearData();
                    vm.saveRequestPrice(true);
                    
                }
                    
//                vm.loading = false;
//                vm.showBackdrop = false;
            }
            reader.readAsText(file);
        } else {
            console.log('file import invalid.');
        }
    },
    onClickImportTemplateCSV() {
        document.getElementById("uploadcsv").click();
        document.getElementById("uploadcsv").addEventListener(
                "change", this.handleFiles, false);
    },
    onClickExportTemplateCSV() {
        if (this.tableRequestPrice.length === 0) {
            this.contentSnackbar = "Please select products in group.";
            this.showSnackbar = true;
            return false;
        }
        this.json_data = [];
        this.json_data_excel = [];
        this.loading = true;
        this.showBackdrop = true;

        let effectiveDate = this.effective_date? moment(this.effective_date, "DD-MM-YYYY").format(
                "YYYY-MM-DD HH:mm:ss"): "";
        let expireDate = this.expire_date? moment(this.expire_date, "DD-MM-YYYY").format(
                "YYYY-MM-DD HH:mm:ss"): "";
        let dataExport = {
            effective_date: effectiveDate,
            expire_date: expireDate,
            emp_code: this.dataToken.code,
            groupbook_id: this.rowRequestPrice._id
        };
        let dataItems = [];
        for (let i = 0; i < this.tableRequestPrice.length; i++) {
            dataItems.push(this.tableRequestPrice[i].code);
        }

        let customerCompare = [];
        if (this.dataCompareCustomer.length > 0) {
            this.dataCompareCustomer.forEach(function(item) {
                if (item.id !== undefined) {
                  customerCompare.push(item.id);
                }
            });
        }
        let datasArray = {
            group_code: this.bookCode,
            docno: this.docNo,
            groupbook_id: this.rowRequestPrice._id,
            c_date: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
            email: "",
            compare_group: customerCompare,
            product: this.tableRequestPrice,
            items: dataItems
        };
        let self = this;
        BookpriceService.exportTemplateCSV(dataExport, datasArray).then(response => {
            let isXLSX = false;
            if (response) {
                if (response.autosave === true) {
                    this.rowRequestPrice.tab = "REQUEST_PRICE";
                    this.rowRequestPrice._id = response.groupbook_id;
                    this.rowRequestPrice.doc_no = response.doc_no;
                    this.docNo = response.doc_no;
                    this.afterExport = true;
                }
              response.items.forEach(function(value, key) {
                let tmp = value[1].price;
                value = value[1].detail;
                value.price = tmp;
                let a1 = "",
                  a3 = "",
                  c2 = "",
                  c1 = "",
                  c0 = "",
                  c3 = "",
                  a2 = "",
                  sr = "",
                  ss = "",
                  price_update = "";
                if (value.price) {
//                  a1 = self.formatNumber(value.A1, 2);
                  a3 = (value.price.A3 === undefined)? '' : self.formatNumber(value.price.A3, 2);
//                  c2 = self.formatNumber(value.C2, 2);
                  c1 = (value.price.C1 === undefined)? '' : self.formatNumber(value.price.C1, 2);
                  c0 = (value.price.C0 === undefined)? '' : self.formatNumber(value.price.C0, 2);
                  //price_update = (value.price[self.bookCode] === null || value.price[self.bookCode] === '')
//                  c3 = self.formatNumber(value.C3, 2);
//                  a2 = self.formatNumber(value.A2, 2);
//                  sr = self.formatNumber(value.SR, 2);
//                  ss = self.formatNumber(value.SS, 2);
                    if(value.price[self.bookCode] === undefined || value.price[self.bookCode] === null || value.price[self.bookCode] === ''){
                        price_update = a3;
                    }else{
                        price_update = self.formatNumber(value.price[self.bookCode], 2);
                    }
                }
                let desc = "", convunit = "";
                if (value.title_th !== undefined && value.title_th !== "") {
                  desc = value.title_th;
                } else if (value.title !== undefined && value.title !== "") {
                  desc = value.title;
                }
                if (value.selling_um_title !== undefined && value.selling_um_title !== "") {
                  convunit = value.selling_um_title;
                }
                if (value.selling_um_conv !== undefined && value.selling_um_conv !== "") {
                  convunit += ' ('+value.selling_um_conv+')';
                }
                
                
                
                if (isXLSX === true) {
                  self.json_data_excel.push({
                    Item_Code: value.code != undefined ? value.title_th : "",
                    Description: desc,
                    A1: {
                      t: "n",
                      v:
                        Description.price && value.price.A1 != undefined
                          ? a1.replace(/,/g, "")
                          : "",
                      z: "#0.00"
                    },
                    A3: {
                      t: "n",
                      v:
                        value.price && value.price.A3 != undefined
                          ? a3.replace(/,/g, "")
                          : "",
                      z: "#0.00"
                    },
                    C2: {
                      t: "n",
                      v:
                        value.price && value.price.C2 != undefined
                          ? c2.replace(/,/g, "")
                          : "",
                      z: "#0.00"
                    },
                    C1: {
                      t: "n",
                      v:
                        value.price && value.price.C1 != undefined
                          ? c1.replace(/,/g, "")
                          : "",
                      z: "#0.00"
                    },
                    C0: {
                      t: "n",
                      v:
                        value.price && value.price.C0 != undefined
                          ? c0.replace(/,/g, "")
                          : "",
                      z: "#0.00"
                    },
                    SR: {
                      t: "n",
                      v:
                        value.price && value.price.SR != undefined
                          ? sr.replace(/,/g, "")
                          : "",
                      z: "#0.00"
                    },
                    SS: {
                      t: "n",
                      v:
                        value.price && value.price.SS != undefined
                          ? ss.replace(/,/g, "")
                          : "",
                      z: "#0.00"
                    },
                    Type:
                      value.productype_code != undefined
                        ? value.productype_code
                        : "",
                    Type_title:
                      value.productype_title != undefined
                        ? value.productype_title
                        : "",
                    Group:
                      value.productgroup_code != undefined
                        ? value.productgroup_code
                        : "",
                    Subgroup:
                      value.productsubgroup_code != undefined
                        ? value.productsubgroup_code
                        : "",
                    CG:
                      value.productcg_code != undefined
                        ? value.productcg_code
                        : "",
                    Conversion_Unit:
                      value.selling_um_title !== undefined
                        ? value.selling_um_title
                        : ""
                  });
                } else {
                  self.json_data.push({
                    Group: value.productgroup_code != undefined? 
                        "'"+value.productgroup_code : "",
                    Subgroup: value.productsubgroup_code != undefined?
                        "'"+value.productsubgroup_code : "",
                    CG: value.productcg_code != undefined?
                        "'"+value.productcg_code : "",
                    Item_Code: value.code != undefined ? "'"+value.code : "",
                    Description: desc,
                    Conversion_Unit: convunit,
//                    A1: {
//                      t: "n",
//                      v:
//                        value.price && value.price.A1 != undefined
//                          ? a1.replace(/,/g, "")
//                          : "",
//                      z: "#0.00"
//                    },
                    A3: value.price && value.price.A3 != undefined
                          ? a3.replace(/,/g, "")
                          : ""
                    ,
//                    C2: {
//                      t: "n",
//                      v:
//                        value.price && value.price.C2 != undefined
//                          ? c2.replace(/,/g, "")
//                          : "",
//                      z: "#0.00"
//                    },
                    C1: value.price && value.price.C1 != undefined
                          ? c1.replace(/,/g, "")
                          : ""
                    ,
                    C0: value.price && value.price.C0 != undefined
                          ? c0.replace(/,/g, "")
                          : ""
                    ,      
//                    SR: {
//                      t: "n",
//                      v:
//                        value.price && value.price.SR != undefined
//                          ? sr.replace(/,/g, "")
//                          : "",
//                      z: "#0.00"
//                    },
//                    SS: {
//                      t: "n",
//                      v:
//                        value.price && value.price.SS != undefined
//                          ? ss.replace(/,/g, "")
//                          : "",
//                      z: "#0.00"
//                    },
                    '%':'-',
                    Price:'-',
                    Price_Update: price_update.replace(/,/g, ""),
                    Margin:'-',
                    
                  });
                }
              });
              let user = Vue.$jwt.decode(localStorage.getItem('token'));
              if (self.json_data.length > 0 || self.json_data_excel.length > 0) {
                if (isXLSX === true) {
                  self.ExportExcelFormat(
                    self.json_data_excel,
                    "_bookprice_",
                    true
                  );
                } else {
                  self.JSONToCSVConvertor(
                    self.json_data, "_bookprice_", true,
                    {
                        'bookcode':this.bookCode,
                        'docno':this.docNo,
                        'effective_date':this.effective_date,
                        'expire_date':this.expire_date,
                        'user':user.username
                    }
                  );
                }
              } else {
                this.dContent = "Please select data for export.";
                this.showSnackbar = true;
              }
              this.loadExport = false;
            }
            this.loading = false;
            this.showBackdrop = false;
          });
//        if(response.errors) {
//            this.contentSnackbar = response.errors.title;
//            this.showSnackbar = true;
//            this.loading = false;
//            this.showBackdrop = false;
//            return false;
//        }
//        if(!response.status) {
//            if(response.error) {
//                this.contentSnackbar = response.error;
//            } else {
//                this.contentSnackbar = "Export limit of 1000 rows";
//            }
//            if(response.data.autosave === true) {
//                this.rowRequestPrice.tab = "REQUEST_PRICE";
//                this.rowRequestPrice._id = response.data.groupbook_id;
//                this.rowRequestPrice.doc_no = response.data.doc_no;
//                this.docNo = response.data.doc_no;
//            }
//            this.showSnackbar = true;
//            this.loading = false;
//            this.showBackdrop = false;
//            return false;
//        } else {
//            if(response.data.autosave === true) {
//                this.rowRequestPrice.tab = "REQUEST_PRICE";
//                this.rowRequestPrice._id = response.data.groupbook_id;
//                this.rowRequestPrice.doc_no = response.data.doc_no;
//                this.docNo = response.data.doc_no;
//            }
//            this.contentSnackbar =
//                "Export data Successfully, Please check the email.";
//                this.showSnackbar = true;
//        }
//        this.loading = false;
//            this.showBackdrop = false;
//        });
    },
    JSONToCSVConvertor(JSONData, ReportTitle, ShowLabel, head) {
        var arrData = typeof JSONData != "object" ? JSON.parse(JSONData) : JSONData;
        var CSV = "";
        if(head){
            let effectiveDate = head.effective_date? moment(head.effective_date, "DD-MM-YYYY").format(
                "DD/MM/YYYY"): "";
            let expireDate = head.expire_date? moment(head.expire_date, "DD-MM-YYYY").format(
                "DD/MM/YYYY"): "";
            CSV += 'Book Code,'+head.bookcode+',Doc No.,'+head.docno+',Effective Date,'+effectiveDate+',Expire Date,'+expireDate+'\r\n\r\n'
        }
        //            CSV += ReportTitle + '\r\n\n';
        if (ShowLabel) {
            var row = "";
            for (var index in arrData[0]) {
                row += index + ",";
            }

            row = row.slice(0, -1);
            CSV += row + "\r\n";
        }

        for (var i = 0; i < arrData.length; i++) {
            let row = "";
            for (let index in arrData[i]) {
                // row += arrData[i][index] + ',';
                //                    if (index != "CG") {
                if (index != "SS") {
                  row += arrData[i][index] + ",";
                } else {
                  row += arrData[i][index];
                }
            }

            row.slice(0, row.length - 1);
            CSV += row + "\r\n";
        }
        if (CSV == "") {
            alert("Invalid data");
            return;
        }

        // var fileName = "MyReport_";
        // fileName += ReportTitle.replace(/ /g, "_");
        var d = new Date();
        var month = d.getMonth() + 1;
        var day = d.getDate();
        var currentDate = d.getFullYear() + (month < 10 ? "0" : "") + month + (day < 10 ? "0" : "") + day;
        var currentTime = (d.getHours() < 10 ? "0" : "") + d.getHours() + (d.getMinutes() < 10 ? "0" : "") + d.getMinutes() + (d.getSeconds() < 10 ? "0" : "") + d.getSeconds();

        var fileName = head.bookcode + head.docno + ReportTitle + currentDate + '_' + currentTime + '_' + head.user;
        var uri = "data:text/csv;charset=utf-8," + encodeURIComponent(CSV);
        var link = document.createElement("a");
        link.href = uri;
        link.style = "visibility:hidden";
        link.download = fileName + ".csv";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    },
    onClickExportTemplate() {
      if (this.tableRequestPrice.length === 0) {
        this.contentSnackbar = "Please select products in group.";
        this.showSnackbar = true;
        return false;
      }

      this.loading = true;
      this.showBackdrop = true;

      let effectiveDate = this.effective_date
        ? moment(this.effective_date, "DD-MM-YYYY").format(
            "YYYY-MM-DD HH:mm:ss"
          )
        : "";
      let expireDate = this.expire_date
        ? moment(this.expire_date, "DD-MM-YYYY").format("YYYY-MM-DD HH:mm:ss")
        : "";
      let dataExport = {
        effective_date: effectiveDate,
        expire_date: expireDate,
        emp_code: this.dataToken.code,
        groupbook_id: this.rowRequestPrice._id
      };

      // let compareGroup =
      //   this.dataCompareCustomer.length === 0 ? [] : this.dataCompareCustomer;
      let dataItems = [];
      for (let i = 0; i < this.tableRequestPrice.length; i++) {
        dataItems.push(this.tableRequestPrice[i].code);
      }

      let customerCompare = [];
      if (this.dataCompareCustomer.length > 0) {
        this.dataCompareCustomer.forEach(function(item) {
          if (item.id !== undefined) {
            customerCompare.push(item.id);
          }
        });
      }

      let datasArray = {
        group_code: this.bookCode,
        docno: this.docNo,
        groupbook_id: this.rowRequestPrice._id,
        c_date: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
        email: "",
        compare_group: customerCompare,
        product: this.tableRequestPrice,
        items: dataItems
      };

      BookpriceService.exportTemplate(dataExport, datasArray).then(response => {
        if (response.errors) {
          this.contentSnackbar = response.errors.title;
          this.showSnackbar = true;
          this.loading = false;
          this.showBackdrop = false;
          return false;
        }
        if (!response.status) {
          if (response.error) {
            this.contentSnackbar = response.error;
          } else {
            this.contentSnackbar = "Export limit of 1000 rows";
          }
          if (response.data.autosave === true) {
            this.rowRequestPrice.tab = "REQUEST_PRICE";
            this.rowRequestPrice._id = response.data.groupbook_id;
            this.rowRequestPrice.doc_no = response.data.doc_no;
            this.docNo = response.data.doc_no;
          }
          this.showSnackbar = true;
          this.loading = false;
          this.showBackdrop = false;
          return false;
        } else {
          if (response.data.autosave === true) {
            this.rowRequestPrice.tab = "REQUEST_PRICE";
            this.rowRequestPrice._id = response.data.groupbook_id;
            this.rowRequestPrice.doc_no = response.data.doc_no;
            this.docNo = response.data.doc_no;
          }
          this.contentSnackbar =
            "Export data Successfully, Please check the email.";
          this.showSnackbar = true;
        }
        this.loading = false;
        this.showBackdrop = false;
      });
    },
    onClickImportFile() {
      this.loading = true;
      BookpriceService.checkDataImport(this.bookCode + this.docNo).then(
        response => {
          // console.log("response ==>", response);
          this.loading = false;

          if (!response.status) {
            this.contentSnackbar = "No user file found.";
            this.showSnackbar = true;
            return false;
          } else {
            // this.modeDialog = "browseFile";
            // this.importConfirmDisable = false;
            this.showDialogImportFile = true;

            // this.listImport = response.file;
            // console.log("response.file ==>", response.file);
            this.dataListImport = response.file.sort(function(a, b) {
              var keyA = new Date(a.modifiedTime),
                keyB = new Date(b.modifiedTime);
              if (keyA < keyB) return 1;
              if (keyA > keyB) return -1;
              return 0;
            });
          }
        }
      );
    },
    onClickCancelImport() {
      this.showDialogImportFile = false;
    },
    onClickComfirmImport(fileID) {
      this.loading = true;
      let eff_date = moment(new Date()).format("YYYY-MM-DD");
      let pricegroup = this.bookCode;
      let dataImport = {
        id: fileID,
        pricegroup: pricegroup,
        eff_date: eff_date
      };

      BookpriceService.importBookPrice(dataImport).then(response => {
        this.loading = false;
        if (response.status !== undefined && !response.status) {
          if (response.spawn) {
            this.contentSnackbar = response.spawn;
            this.showSnackbar = true;
          } else {
            // console.log("response.error ==>", response.error);
            this.showMsgImport = true;
            this.listError = response.error;
          }
          return false;
        } else {
          if (response.data) {
            this.tableRequestPrice = [];
            response.data.sort((a, b) => (a.iprod > b.iprod ? 1 : -1));
            response.data.forEach(items => {
              //   let key = this.tableRequestPrice.findIndex(item => {
              //     return items.iprod === item.code;
              //   });

              //   if (key === -1) {
              this.tableRequestPrice.push({
                code: items.iprod,
                title_th: items.title_th,
                cost: items.cost === "" ? "" : items.cost,
                A3:
                  items.a3_price === "" 
                    ? ""
                    : items.a3_price,
                SS:
                  items.ss_price === "" 
                    ? ""
                    : items.ss_price,
                price_old:
                  items.price_old === "" 
                    ? ""
                    : items.price_old,
                price_book:
                  items.price_book === "" 
                    ? ""
                    : items.price_book
              });
              // } else {
              //   this.tableRequestPrice[key].cost =
              //     items.cost === "" || items.cost === 0 ? "" : items.cost;
              //   this.tableRequestPrice[key].A3 =
              //     items.a3_price === "" || items.a3_price === 0
              //       ? ""
              //       : items.a3_price;
              //   this.tableRequestPrice[key].price_book =
              //     items.price_book === "" || items.price_book === 0
              //       ? ""
              //       : items.price_book;
              // }
            });

            this.loadDatacompareCustomer();
          }

          this.contentSnackbar = "Import data successfully.";
          this.showSnackbar = true;
        }
      });

      this.showDialogImportFile = false;
    },
    onSaveMemo() {
      this.checkEvent = "reject";
      this.saveComment(this.memoComment);
      this.onConfirm();
    }
  }
};
</script>

<style lang="scss">
.mktops-request-price {
  &.mkt-ops.-main-font {
    font-weight: 400;
  }

  .md-layout {
    &.-block {
      padding: 5px 18px 0px;

      .md-layout-item {
        &.pt23 {
          padding-top: 23px;
        }

        .-label {
          margin-bottom: 5px;

          &.-title {
            font-weight: 300;
          }
        }

        .nowrap-title {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .font-kanit {
          font-size: 14px;
          font-family: kanit;
          font-weight: 300;
        }

        .multiselect {
          width: 30%;

          .multiselect__tags {
            height: 36px;
            min-height: 36px;
            padding-top: 5px;
          }

          .multiselect__select {
            padding-top: 0px;
          }
        }

        .mx-datepicker input {
          height: 36px;
        }

        .md-radio {
          margin: 0px;
          .md-radio-label {
            padding-left: 10px;
            margin-right: 40px;
          }
        }

        &.block-action .input-search {
          width: 100%;
        }
      }

      &.table-request-price {
        .divHeadList {
          width: 99.6%;
          // div {
          //   border: 1px solid pink;
          // }
        }

        .divBodyList.calheight {
          // height: calc(100vmin - 301px);
          height: calc(100vmin - 342px);
        }

        .divBodyList {
          //height: calc(100vmin - 339px);
          // height: calc(100vmin - 401px); // ROW-4 Temporary for initial data
          height: calc(100vmin - 309px); // ROW-4 Temporary for initial data

          > div {
            height: unset;
            padding-top: 6px;
            padding-bottom: 6px;

            // div {
            //   border: 1px solid pink;
            // }

            .main-row {
              padding: 0px;
              display: -webkit-inline-box;
            }

            .-blue {
              padding: 0px;
              color: #110af2;
              font-size: 11px;
            }

            .-red {
              padding: 0px;
              color: #f44336;
              font-size: 11px;
            }
          }
        }
      }
    }

    .custom-datepicker {
      &.md-field {
        padding-top: 0px;
        min-height: 31px;
        margin-bottom: 0px;

        > .md-icon:after {
          height: 0px;
        }
      }

      .md-icon {
        margin-bottom: 0px;
      }

      input {
        font-size: 13px;
      }
    }

    .-action {
      text-align: right;

      .md-button {
        height: 32px;
        border-radius: 3px;
        font-size: 12px;
        font-weight: 700;

        &.-flex .md-button-content {
          display: flex;
        }

        .md-ripple {
          padding-left: 12px;
          padding-right: 10px;
        }
      }
    }
  }

  .select-item-comment {
    position: absolute;
    bottom: 57px;
    left: 169px;
    background: #edf2f8;
    border: 1px solid #51a2e7;
    border-radius: 10px;
    width: 65%;
    height: calc(100vmin - 110px);
    z-index: 8;
    padding: 25px 25px 25px 30px;

    .block-scroll {
      display: block;
      overflow-y: scroll;
      height: calc(100vmin - 225px);

      &::-webkit-scrollbar {
        height: 7px;
        width: 5px;
      }
      &::-webkit-scrollbar-thumb {
        background: #edf2f8;
      }
    }

    .md-layout.content {
      padding: 15px;
      background: white;
      margin: 15px 0;

      .md-layout-item {
        .font-kanit {
          font-family: Kanit;
        }

        &.display-flex {
          display: flex;

          .md-icon {
            font-weight: normal;
            font-size: 30px !important;
            color: #51a2e7;
            margin: 0 15px 0 0;
          }

          > div {
            font-size: 16px;
            font-weight: bold;
            color: #51a2e7;
            padding-top: 3px;
          }

          .displayName {
            font-size: 14px;
            font-weight: 400;
            color: #767676;
          }

          .displayStatus {
            margin-left: 10px !important;
            margin-top: 2px;
            font-family: Lato;
            font-weight: 400;
            padding-left: 8px;
            padding-right: 8px;
            border-radius: 50px;
            color: #ffffff;
            font-size: 12px;
            margin-left: 5px;
            max-height: 16px;
            line-height: 16px;
          }
        }

        &.date {
          font-size: 14px;
          font-weight: bold;
          color: #414141;
          opacity: 0.56;
          text-align: right;
        }

        &.-head {
          font-family: Kanit;
          font-size: 14px;
          color: #414141;
          padding: 0 0 10px;
        }
        &.-detail {
          font-family: Kanit;
          font-size: 13px;
          color: #464242;
          opacity: 0.56;
          padding: 1px 0 0 15px;
        }

        &.-textarea {
          width: 100%;
          color: #727272;
          margin-top: 10px;

          textarea {
            width: 100%;
            min-width: 100%;
            max-width: 100%;
            min-height: 90px;
            max-height: 90px;
            font-size: 14px;
            font-family: kanit;
            margin-top: 10px;
            padding-left: 8px;
            padding-right: 13.8px;
            border: 1px solid #51a2e7;
            border-radius: 5px;
            background: #fff;
          }
          ::placeholder {
            color: #bdbdbd;
            opacity: 1;
            font-size: 14px;
            font-family: lato;
          }
        }
      }
    }
  }

  .bg-backdrop,
  .bg-backdrop {
    &.-sparse {
      background: rgba(0, 0, 0, 0.28) !important;
    }
    background: rgba(0, 0, 0, 0.6);
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 7;
    top: 0;
    left: 0;
  }
}

.volumepricing.bookprice.dialog-alert {
  height: 70% !important;
  top: 15% !important;

  .dialog-content .scrollbar {
    overflow-y: scroll;
    height: calc(70vmin - 320px);

    &::-webkit-scrollbar {
      height: 7px;
      width: 5px;
    }
  }

  .bg-backdrop {
    &.-sparse {
      background: rgba(0, 0, 0, 0.28) !important;
    }
    background: rgba(0, 0, 0, 0.6);
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 7;
    top: 0;
    left: 0;
  }
}
</style>
